import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/seo/SEO";

const NotFound = () => {
  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen bg-[#F7F7F4] flex items-center justify-center px-6"
    >
      <SEO title="Page not found" description="The page you're looking for doesn't exist." path="/404" noindex />
      <div className="max-w-xl text-center">
        <div className="overline">— 404</div>
        <h1 className="mt-4 font-sora text-[60px] sm:text-[80px] font-extrabold tracking-tight leading-none text-[#111111]">
          Not here.
        </h1>
        <p className="mt-6 font-manrope text-[16px] md:text-[17px] text-[#111111]/65 leading-relaxed">
          The page you&rsquo;re looking for doesn&rsquo;t exist — or has been
          quietly retired.
        </p>
        <Link
          to="/"
          className="mt-10 inline-flex items-center gap-2 bg-[#111111] hover:bg-[#2563EB] text-white font-manrope font-medium text-[15px] px-6 py-3.5 rounded-lg transition-colors"
        >
          Back to Vaymilo
          <ArrowUpRight size={16} strokeWidth={2.25} />
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
